import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import type { PaidMediaOverviewWarning } from "src/services/PaidMediaOverviewAPI";

interface OverviewWarningsBannerProps {
  warnings: PaidMediaOverviewWarning[];
}

const OverviewWarningsBanner: FC<OverviewWarningsBannerProps> = ({ warnings }) => {
  const { t } = useTranslation();

  if (!warnings?.length) {
    return null;
  }

  return (
    <div className="paid-media-overview__warnings" role="status">
      <span className="paid-media-overview__warnings-icon" aria-hidden>
        <AlertTriangle size={14} />
      </span>
      <div className="paid-media-overview__warnings-body">
        <strong className="paid-media-overview__warnings-title">
          {t("paidMediaOverview.warnings.title")}
        </strong>
        <ul className="paid-media-overview__warnings-list">
          {warnings.map(warning => (
            <li key={`${warning?.code ?? ""}-${warning?.message}`}>{warning?.message}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OverviewWarningsBanner;
